import { UserPermissionEnum } from './permissions/user-permission.enum';
import { UserRoleEnum } from './permissions/user-role.enum';

export class UserRoleModel {
  role_id: number;
  role_name: UserRoleEnum;
  role_display_name: string;
  role_description: string;

  permissions: UserPermissionEnum[];
}
